export default {
  mediaUploadImage: "Seleccione un archivo de imagen",
  mediaUploadVideo: "Seleccione un archivo de vídeo",
  mediaUploadEither: "Seleccione un archivo de imagen o vídeo",
  mediaUploadMax: "El archivo debe ser inferior a {{max}}",
  mediaUploadSuccess: "{{type}} subido",
  storageUploadProcessing: "Guardando en el servidor...",
  storageUploadPercent: "{{percent}}%",
  storageUploadTooLarge: "Archivo demasiado grande. Tamaño máximo {{max}}.",
  storageUploadFailed: "No se pudo subir el archivo",
  storageUploadFailedNamed: "Error al subir {{name}}",
  storageUploadFileProgress: "Subiendo {{name}} ({{current}} de {{total}})",
  mediaUploadButton: "Subir",
  imageCrop: {
    title: "Recortar foto",
    confirm: "Usar foto",
    cancel: "Omitir",
    zoom: "Zoom",
    failed: "No se pudo recortar esta foto. Pruebe con otra imagen.",
  },
  receiptUploadAnalyzing: "Analizando...",
  receiptUploadLabel: "Subir ticket",
  receiptUploadBeforeVisit:
    "Esta acción solo está disponible después de la hora de inicio de la reserva",
  receiptUploadTooLarge: "Archivo demasiado grande. Tamaño máximo {{max}}.",
  receiptUploadUnsupported: "Sube una imagen o un PDF del ticket.",
  receiptModalTitle: "Ticket subido",
  receiptModalSubtitle: "Verifique el total extraído",
  receiptModalExtracted: "Total extraído del ticket:",
  receiptModalConfirmHint: "Confirme que este importe es correcto",
  receiptModalMismatch:
    "¿Es correcto este importe? Si el total no coincide con el ticket, elija «Volver a fotografiar».",
  receiptModalConfirming: "Confirmando...",
  receiptModalYes: "Sí, es correcto",
  receiptModalRetake: "No, volver a fotografiar",
  receiptOcrFailureTitle: "No se pudo leer el ticket",
  receiptOcrFailureAttemptsRemaining:
    "{{remaining}} de {{max}} intentos de validación restantes",
  receiptOcrFailureManualHint:
    "La lectura automática no tuvo éxito. Puedes subir otra foto o introducir el total manualmente.",
  receiptOcrFailureRetry: "Subir otra foto",
  receiptOcrFailureManualAmount: "Introducir total manualmente",
  receiptPreviewAlt: "Foto del ticket",
  receiptViewFull: "Ver foto del ticket",
  receiptDownload: "Descargar ticket",
  receiptDownloadFailed: "No se pudo descargar el ticket. Inténtalo de nuevo.",
  attachmentViewFull: "Ver imagen",
  attachmentDownload: "Descargar",
  attachmentDownloadFailed:
    "No se pudo descargar el archivo. Inténtalo de nuevo.",
  countrySelectSearchPlaceholder: "Buscar país...",
  countrySelectNoResults: "No se encontró ningún país",
  multiSelectPlaceholder: "Seleccionar opciones...",
  multiSelectRemoveChip: "Eliminar {{label}}",
  receiptManualAmountTitle: "Introduce el total manualmente",
  receiptManualAmountSubtitle:
    "No se pudo leer el ticket automáticamente. Introduce el importe total que aparece en el ticket.",
  receiptManualAmountLabel: "Total del ticket (EUR)",
  receiptManualAmountPlaceholder: "p. ej. 42,50",
  receiptManualAmountInvalid: "Introduce un importo válido mayor que cero",
  receiptManualAmountSubmit: "Guardar total",
  transactionCustomer: "Cliente:",
  transactionOpenBooking: "Abrir reserva",
  walletMovements: {
    badges: {
      income: "Ingreso",
      expense: "Gasto",
      settlement: "Liquidación",
      refund: "Reembolso",
    },
    checkout_payment: {
      title: "Pago del cliente",
    },
    restaurant_fee: {
      title: "Abono de comisión de restaurante",
    },
    refund: {
      title: "Ajuste por reembolso",
    },
    settlement_sent: {
      title: "Liquidación transferida a su cuenta bancaria",
      titleWithReference:
        "Liquidación transferida a su cuenta bancaria (ref: {{reference}})",
    },
    settlement_received: {
      title: "Liquidación recibida en la cartera",
      titleWithReference:
        "Liquidación recibida en la cartera (ref: {{reference}})",
    },
    host_payout: {
      title: "Pago al anfitrión",
    },
    host_commission: {
      title: "Comisión",
    },
    sales_agent_commission: {
      title: "Comisión del agente de ventas",
    },
    internal_fee: {
      title: "Ajuste de comisión de la plataforma",
    },
    unknown: {
      title: "Movimiento de cartera",
    },
  },
  translationAllRequired: "Todos los idiomas obligatorios",
  translationCharCount: "{{current}}/{{max}}",
  translationOverLimit:
    "Uno o más idiomas superan el límite de {{max}} caracteres. Acorta el texto en los idiomas en rojo.",
  mediaTypeImage: "Imagen",
  mediaTypeVideo: "Vídeo",
  itemThumbnailAlt: "Imagen del elemento",
  productItem: {
    imageTooLarge: "Imagen demasiado grande. Tamaño máximo 10 MB.",
    menuItemCreated: "Plato del menú creado",
    serviceCreated: "Servicio creado",
    menuItemUpdated: "Plato del menú actualizado",
    serviceUpdated: "Servicio actualizado",
    noCategory: "Sin categoría",
    titleEditMenu: "Editar plato del menú",
    titleEditService: "Editar servicio",
    titleAddMenu: "Añadir plato al menú",
    titleAddService: "Añadir servicio",
    allTranslationsRequired: "El nombre es obligatorio en todos los idiomas",
    descriptionPartial:
      "La descripción debe estar vacía o traducida en todos los idiomas",
    autoTranslateHint:
      "El nombre es obligatorio en todos los idiomas; la descripción debe estar vacía o completa en todos los idiomas. Rellene al menos un idioma y genere las traducciones. Tras un cambio de nombre, genere de nuevo para actualizar los demás idiomas.",
    autoTranslateGenerate: "Generar traducciones",
    autoTranslateConfirmTitle: "¿Completar traducciones faltantes?",
    autoTranslateConfirm:
      "Se generarán traducciones solo para los idiomas vacíos. El texto existente no se modificará.",
    autoTranslateRefreshTitle: "¿Actualizar los demás idiomas?",
    autoTranslateRefreshConfirm:
      "Todos los idiomas ya tienen texto. Los demás idiomas se sustituirán con traducciones del idioma de origen.",
    autoTranslateApplied: "Traducciones aplicadas",
    validPriceRequired: "Introduzca un precio válido",
    showKioskDiscountLabel: "Mostrar como descuento en los dispositivos",
    showKioskDiscountHint:
      "El precio con descuento se mostrará en los dispositivos y es el que pagarán los clientes.",
    undiscountedPriceEuro: "Precio sin descuento (€)",
    discountedPriceEuro: "Precio con descuento (€)",
    validUndiscountedPriceRequired: "Introduzca un precio sin descuento válido",
    validDiscountedPriceRequired: "Introduzca un precio con descuento válido",
    discountedMustBeLower:
      "El precio con descuento debe ser inferior al precio sin descuento",
    photo: "Foto",
    photoHint: "Máx. 10 MB",
    addPhoto: "Añadir foto",
    category: "Categoría",
    priceEuro: "Precio (€)",
    name: "Nombre",
    description: "Descripción",
    placeholderPriceMenu: "12,50",
    placeholderPriceService: "25,00",
    placeholderNameMenu: "Nombre del plato",
    placeholderNameService: "Nombre del servicio",
    placeholderDescMenu: "Descripción del plato",
    placeholderDescService: "Descripción del servicio",
    hintDescMenu: "Opcional: ingredientes, preparación, etc.",
    hintDescService: "Opcional: qué incluye el servicio",
    previewAlt: "Vista previa",
    saveChanges: "Guardar cambios",
    addItem: "Añadir plato",
    addService: "Añadir servicio",
  },
  productItems: {
    menu: {
      title: "Menú",
      emptyTitle: "Aún no hay platos en el menú",
      emptySubtitle: "Añada su primer plato al menú",
      addButton: "Añadir plato",
      deleteSuccess: "Plato del menú eliminado",
    },
    service: {
      title: "Servicios ofrecidos",
      emptyTitle: "Aún no hay servicios",
      emptySubtitle: "Añada los servicios que ofrece a los clientes",
      addButton: "Añadir servicio",
      deleteSuccess: "Servicio eliminado",
    },
    toastDeleteErrorMenu: "Error al eliminar el plato del menú",
    toastDeleteErrorService: "Error al eliminar el servicio",
    toastUpdateErrorMenu: "Error al actualizar el plato del menú",
    toastUpdateErrorService: "Error al actualizar el servicio",
    toastReorderError: "Error al reordenar los elementos",
    confirmDelete: "¿Eliminar «{{name}}»?",
    thisItem: "este elemento",
    filterAll: "Todos ({{count}})",
    uncategorized: "Sin categoría ({{count}})",
  },
  transactionsSection: {
    titleDefault: "Movimientos",
    filters: "Filtros",
    dateRange: "Rango de fechas",
    activity: "Actividad",
    allActivities: "Todas las actividades",
    searchInDescription: "Buscar en la descripción",
    searchPlaceholder: "Buscar...",
    minAmountEuro: "Importe mínimo (€)",
    minAmountPlaceholder: "0,00",
    maxAmountEuro: "Importe máximo (€)",
    noLimit: "Sin límite",
    reset: "Restablecer",
    applyFilters: "Aplicar filtros",
    credits: "Ingresos",
    debits: "Gastos",
    transactionsCountLabel: "Movimientos",
    loadingTransactions: "Cargando movimientos...",
    emptyTitle: "Sin movimientos",
    emptyDescription: "No se encontraron movimientos",
  },
  sortableItem: {
    itemAltFallback: "Elemento",
    hidden: "Oculto",
    hide: "Ocultar",
    show: "Mostrar",
    discounted: "Con descuento",
  },
} as const;
